import { OdataFieldBasicOperator } from './OdataFieldBasicOperator';
import { IOdataField } from '../../IOdataField';

export class OdataFieldDay extends OdataFieldBasicOperator {
  constructor(field: IOdataField) {
    super(field, 'day');
  }
}
